import { state } from "./data";

let actions = null;

export { actions as default };

/**
  *  Init Actions: (Mutate actions variable and export it);
  *  initialization is needed for inject Vue component instance.
  *  usually init it in root component created hook.
  *  @param  {VueComponent} root The instance of root component;
  */

 export const initActions = (root) => {
  if (root) {
    if (root._isVue) {
      actions = {
        isValid: true,
        add: add(root),
        refresh: refresh(root),
        bulkImport: bulkImport(root)
      }
    }
  }
}


/**
  *  Refresh: Click this and data of the page will be refreshed.
  *  @param  {VueInstance} root The Vue instance of this page 's root component. 
  *  @return {Object}           The object contain a page action.
  */

function refresh (root) {
  return {
    name: "refresh",
    title: "Refresh",
    classes: ['button-green'],
    handlers: {
      click() {
        // Load data from root component and leverage the use its lifecycle mechanism.
        root.loadData();
      }
    }
  }
}


/**
 *  Add: add a new data set according to the page, data usually a list shows in list table.
 *  @param  {VueInstance} root The Vue instance of this page 's root component. 
 *  @return {Object}           The object contain a page action.
 */

function add (/* root */) {
  return {
    name: "add",
    title: "Add",
    classes: ['button-red'],
    handlers: {
      click: () => {
        // Mutate state for activate local editor.
        state.local.editor = { name: "EditExam", mode: "add", active: true };
      }
    }
  }
}


/**
 *  bulkImport: import a new data set according to the page, data usually a list shows in list table.
 *  @param  {VueInstance} root The Vue instance of this page 's root component. 
 *  @return {Object}           The object contain a page action.
 */

function bulkImport (root) {
  return {
    name: "import",
    title: "Import",
    classes: ['button-red'],
    handlers: {
      click: () => {
        root.upload();
      }
    }
  }
}
